import { Link } from "react-router-dom";
import LegalLayout, { LegalFooter, legalStyles } from "../layouts/LegalLayout";

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#f4f7fe",
    fontFamily: "Arial, sans-serif",
  },
  navbar: {
    background: "#fff",
    padding: "14px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  navLogo: {
    fontSize: 20,
    fontWeight: 800,
    color: "#4318FF",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  navLink: {
    color: "#374151",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
  },
  navLoginBtn: {
    background: "#4318FF",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "none",
  },
  hero: {
    background: "linear-gradient(135deg, #4318FF, #7551FF)",
    color: "#fff",
    padding: "60px 20px",
    textAlign: "center",
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    margin: "0 0 16px 0",
  },
  heroSubtitle: {
    fontSize: 18,
    fontWeight: 400,
    margin: 0,
    opacity: 0.9,
    maxWidth: 600,
    marginLeft: "auto",
    marginRight: "auto",
    lineHeight: 1.6,
  },
  content: {
    maxWidth: 800,
    margin: "0 auto",
    padding: "40px 20px",
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
  },
  sectionHeading: {
    fontSize: 17,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  bodyText: {
    fontSize: 14,
    color: "#374151",
    lineHeight: 2,
    margin: 0,
  },
  stepsGrid: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    marginTop: 8,
  },
  stepCard: {
    flex: "1 1 200px",
    background: "#f4f7fe",
    borderRadius: 12,
    padding: "20px 16px",
    textAlign: "center",
    border: "1px solid #e5e7eb",
  },
  stepNumber: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "#4318FF",
    color: "#fff",
    fontSize: 18,
    fontWeight: 800,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 12px auto",
  },
  stepTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1b2559",
    marginBottom: 6,
  },
  stepDesc: {
    fontSize: 13,
    color: "#374151",
    lineHeight: 1.7,
    margin: 0,
  },
  statsGrid: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    marginTop: 8,
  },
  statCard: {
    flex: "1 1 160px",
    background: "linear-gradient(135deg, #4318FF, #7551FF)",
    borderRadius: 12,
    padding: "20px 16px",
    textAlign: "center",
    color: "#fff",
  },
  statNumber: {
    fontSize: 28,
    fontWeight: 800,
    margin: "0 0 4px 0",
  },
  statLabel: {
    fontSize: 12,
    opacity: 0.9,
    margin: 0,
  },
  valuesGrid: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    marginTop: 8,
  },
  valueItem: {
    flex: "1 1 160px",
    background: "#f4f7fe",
    borderRadius: 12,
    padding: "16px",
    border: "1px solid #e5e7eb",
  },
  valueIcon: {
    fontSize: 24,
    marginBottom: 8,
  },
  valueTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1b2559",
    marginBottom: 4,
  },
  valueDesc: {
    fontSize: 12,
    color: "#374151",
    lineHeight: 1.6,
    margin: 0,
  },
  contactRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 0",
    borderBottom: "1px solid #f0f0f0",
    fontSize: 14,
    color: "#374151",
  },
  contactIcon: {
    fontSize: 18,
    width: 28,
    textAlign: "center",
    color: "#4318FF",
  },
  contactLink: {
    color: "#4318FF",
    textDecoration: "none",
    fontWeight: 600,
  },
  footer: {
    background: "#1b2559",
    color: "#fff",
    padding: "30px 20px",
    textAlign: "center",
  },
  footerLinks: {
    display: "flex",
    justifyContent: "center",
    gap: 24,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  footerLink: {
    color: "#a0aec0",
    textDecoration: "none",
    fontSize: 13,
  },
  footerText: {
    fontSize: 13,
    color: "#a0aec0",
    margin: "4px 0",
  },
};

const AboutUs = () => {
  return (
    <LegalLayout activePage="about">
      {/* Hero */}
      <div style={legalStyles.hero}>
        <h1 style={legalStyles.heroTitle}>About FraudCheck FDS</h1>
        <p style={legalStyles.heroSubtitle}>
          India's dedicated fraud prevention network for self-drive car rental owners — built to protect your business, your vehicles, and your livelihood.
        </p>
      </div>

      {/* Content */}
      <div style={legalStyles.content}>

        {/* Mission */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Our Mission</h2>
          <p style={legalStyles.bodyText}>
            At FraudCheck FDS, our mission is clear and unwavering: <strong>to protect self-drive car rental owners across India from fraudulent customers.</strong> Every day, rental owners across the country face the risk of vehicle damage, non-payment, identity fraud, and theft from customers who exploit the trust-based nature of self-drive rentals. We exist to eliminate that risk.
          </p>
          <p style={{ ...legalStyles.bodyText, marginTop: 12 }}>
            We provide a centralized, verified database of fraud reports that allows rental owners to cross-check customers before handing over vehicle keys — giving you the power to make informed decisions and protect your hard-earned business.
          </p>
        </div>

        {/* Vision */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Our Vision</h2>
          <p style={legalStyles.bodyText}>
            We envision <strong>India's most trusted and comprehensive fraud prevention network for vehicle rentals</strong> — a platform where every self-drive rental owner, from Kanyakumari to Kashmir, has access to real-time fraud intelligence and can run their business with confidence and security.
          </p>
          <p style={{ ...legalStyles.bodyText, marginTop: 12 }}>
            Our vision is a rental ecosystem where honest customers thrive, fraudulent actors are identified swiftly, and rental businesses grow sustainably without fear of exploitation.
          </p>
        </div>

        {/* How It Works */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>How FraudCheck FDS Works</h2>
          <p style={{ ...legalStyles.bodyText, marginBottom: 16 }}>
            Getting started is simple. Our platform is designed for busy rental owners who need results fast — not complicated software.
          </p>
          <div style={legalStyles.stepsGrid}>
            <div style={legalStyles.stepCard}>
              <div style={legalStyles.stepNumber}>1</div>
              <p style={legalStyles.stepTitle}>Register Your Business</p>
              <p style={legalStyles.stepDesc}>
                Sign up with your business details, choose a subscription plan, and get instant access to the FraudCheck FDS platform. Verification ensures only genuine rental owners join the network.
              </p>
            </div>
            <div style={legalStyles.stepCard}>
              <div style={legalStyles.stepNumber}>2</div>
              <p style={legalStyles.stepTitle}>Report Fraud Cases</p>
              <p style={legalStyles.stepDesc}>
                Encountered a fraudulent customer? Report them with details like Aadhaar/DL number, name, phone, photos, and incident description. Your report protects the entire rental community.
              </p>
            </div>
            <div style={legalStyles.stepCard}>
              <div style={legalStyles.stepNumber}>3</div>
              <p style={legalStyles.stepTitle}>Search Before You Rent</p>
              <p style={legalStyles.stepDesc}>
                Before handing over your vehicle keys, search the customer's ID or phone number in our database. Get instant results on whether they have been flagged by other owners.
              </p>
            </div>
          </div>
        </div>

        {/* Why It Matters */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Why This Matters — The Reality of Rental Fraud in India</h2>
          <p style={legalStyles.bodyText}>
            The self-drive car rental industry in India is growing rapidly, with thousands of independent owners operating across every city and town. However, this growth has also attracted a rising tide of fraudulent actors who exploit the informal, trust-based nature of vehicle rentals.
          </p>
          <p style={{ ...legalStyles.bodyText, marginTop: 12 }}>
            Common fraud patterns include:
          </p>
          <ul style={{ ...legalStyles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 6 }}>Customers using <strong>fake or forged Aadhaar cards and driving licences</strong> to rent vehicles</li>
            <li style={{ marginBottom: 6 }}><strong>Vehicle theft</strong> — renting and never returning the car</li>
            <li style={{ marginBottom: 6 }}><strong>Deliberate damage</strong> to vehicles and denial of responsibility</li>
            <li style={{ marginBottom: 6 }}><strong>Non-payment</strong> — disputing charges after usage</li>
            <li style={{ marginBottom: 6 }}>Using rental vehicles for <strong>illegal activities</strong> such as smuggling or unauthorized sub-renting</li>
            <li style={{ marginBottom: 6 }}>Repeat offenders who move from <strong>city to city</strong>, targeting different owners</li>
          </ul>
          <p style={{ ...legalStyles.bodyText, marginTop: 12 }}>
            Without a centralized reporting system, the same fraudulent customer can exploit dozens of rental owners before facing any consequences. FraudCheck FDS breaks this cycle by enabling the rental community to share verified fraud intelligence in real time.
          </p>
          <div style={legalStyles.statsGrid}>
            <div style={legalStyles.statCard}>
              <p style={legalStyles.statNumber}>60%+</p>
              <p style={legalStyles.statLabel}>of rental fraud involves fake identity documents</p>
            </div>
            <div style={legalStyles.statCard}>
              <p style={legalStyles.statNumber}>Multi-city</p>
              <p style={legalStyles.statLabel}>repeat offenders target owners across states</p>
            </div>
            <div style={legalStyles.statCard}>
              <p style={legalStyles.statNumber}>₹ Lakhs</p>
              <p style={legalStyles.statLabel}>average annual loss per unprotected rental owner</p>
            </div>
          </div>
        </div>

        {/* Our Values */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Our Values</h2>
          <div style={legalStyles.valuesGrid}>
            <div style={legalStyles.valueItem}>
              <div style={legalStyles.valueIcon}>🛡️</div>
              <p style={legalStyles.valueTitle}>Trust & Verification</p>
              <p style={legalStyles.valueDesc}>Every report is submitted by a verified rental owner, ensuring accuracy and accountability.</p>
            </div>
            <div style={legalStyles.valueItem}>
              <div style={legalStyles.valueIcon}>🤝</div>
              <p style={legalStyles.valueTitle}>Community First</p>
              <p style={legalStyles.valueDesc}>We are stronger together. Every report you file protects not just you, but every owner in the network.</p>
            </div>
            <div style={legalStyles.valueItem}>
              <div style={legalStyles.valueIcon}>🔒</div>
              <p style={legalStyles.valueTitle}>Data Privacy</p>
              <p style={legalStyles.valueDesc}>We handle all data responsibly under Indian law, including the IT Act 2000 and SPDI Rules 2011.</p>
            </div>
            <div style={legalStyles.valueItem}>
              <div style={legalStyles.valueIcon}>⚡</div>
              <p style={legalStyles.valueTitle}>Speed & Reliability</p>
              <p style={legalStyles.valueDesc}>Real-time search results when you need them most — before the keys change hands.</p>
            </div>
          </div>
        </div>

        {/* Who We Serve */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Who We Serve</h2>
          <p style={legalStyles.bodyText}>
            FraudCheck FDS is built exclusively for <strong>self-drive car rental business owners across India</strong>. Whether you operate a single vehicle or a fleet of fifty, whether you run your business in a metro city or a Tier-2/Tier-3 town, our platform is designed to protect you.
          </p>
          <p style={{ ...legalStyles.bodyText, marginTop: 12 }}>
            We serve owners across all states — from Andhra Pradesh and Telangana to Maharashtra, Tamil Nadu, Karnataka, Gujarat, Rajasthan, Delhi, and beyond. Our pan-India coverage means fraud reports filed anywhere in the country are instantly available to owners everywhere.
          </p>
        </div>

        {/* Legal Compliance */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Legal Compliance & Governance</h2>
          <p style={legalStyles.bodyText}>
            FraudCheck FDS operates in full compliance with Indian law. Our platform is governed by:
          </p>
          <ul style={{ ...legalStyles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 6 }}><strong>Information Technology Act, 2000</strong> and IT (Amendment) Act, 2008</li>
            <li style={{ marginBottom: 6 }}><strong>IT (Reasonable Security Practices) Rules, 2011</strong> — protecting your personal data</li>
            <li style={{ marginBottom: 6 }}><strong>Indian Contract Act, 1872</strong> — governing our subscription agreements</li>
            <li style={{ marginBottom: 6 }}><strong>Consumer Protection Act, 2019</strong> — ensuring fair business practices</li>
          </ul>
          <p style={{ ...legalStyles.bodyText, marginTop: 12 }}>
            All disputes are subject to the jurisdiction of competent courts in Andhra Pradesh / Telangana, India. Our platform is operated from India and all data is processed and stored as per Indian data protection standards.
          </p>
        </div>

        {/* Contact */}
        <div style={legalStyles.card}>
          <h2 style={legalStyles.sectionHeading}>Contact Us</h2>
          <p style={{ ...legalStyles.bodyText, marginBottom: 16 }}>
            We are here to help. Reach out to us for support, questions, or partnership inquiries.
          </p>
          <div style={{ ...legalStyles.contactRow, borderTop: "1px solid #f0f0f0" }}>
            <span style={legalStyles.contactIcon}>🌐</span>
            <span>Website: <a href="https://fds.uvars.com" style={legalStyles.contactLink} target="_blank" rel="noreferrer">fds.uvars.com</a></span>
          </div>
          <div style={legalStyles.contactRow}>
            <span style={legalStyles.contactIcon}>📧</span>
            <span>Email: <a href="mailto:admin.umasankar@gmail.com" style={legalStyles.contactLink}>admin.umasankar@gmail.com</a></span>
          </div>
          <div style={legalStyles.contactRow}>
            <span style={legalStyles.contactIcon}>📞</span>
            <span>Phone: <a href="tel:7207270218" style={legalStyles.contactLink}>7207270218</a></span>
          </div>
          <div style={{ ...legalStyles.contactRow, borderBottom: "none" }}>
            <span style={legalStyles.contactIcon}>📍</span>
            <span>Jurisdiction: Andhra Pradesh / Telangana, India</span>
          </div>
        </div>

      </div>

      <LegalFooter />
    </LegalLayout>
  );
};

export default AboutUs;
